export default __webpack_public_path__ + "static/media/404.1a94db30.svg";